import React from 'react'

import { Badge } from '@cmsgov/design-system'

import { MessageList } from '../MessageList/MessageList'

import Message from '../../models/Message'

export interface MessageInboxProps {
  messages?: Message[];
  onMarkAllAsReadClick?: () => void;
}

export const MessageInbox: React.FC<MessageInboxProps> = ({ messages = [], onMarkAllAsReadClick }) => {
  const unreadMessages = messages.filter(message => !message.read)
  const readMessages = messages.filter(message => message.read)

  return (
    <div>
      <MessageList
        header={(
          <span>
            Unread {
              unreadMessages.length
                ? <Badge className='ch-c-badge' variation='warn' data-testid='unread-badge'>{unreadMessages.length}</Badge>
                : ''
            }
          </span>
        )}
        headerAction={(<button className='ch-c-btn__link' onClick={onMarkAllAsReadClick}>Mark all as read</button>)}
        messages={unreadMessages}
        emptyText='You have no unread messages'
      />

      <MessageList
        header='Read'
        messages={readMessages}
        emptyText='You have no read messages'
      />
    </div>
  )
}
